"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateId = void 0;
var generateId = function () { return Math.random().toString(26).slice(2); };
exports.generateId = generateId;
//# sourceMappingURL=generateId.js.map